import { actionTypeWrapper } from '../../utils/actionTypeWrapper'

export enum ArrayActionType {
  ADD = 'ADD',
  REPLACE_ALL = 'REPLACE_ALL',
  REMOVE_BY_INDEX = 'REMOVE_BY_INDEX',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
  UPDATE_BY_INDEX = 'UPDATED_BY_INDEX',
}

const addRow = () => ({ type: ArrayActionType.ADD })

const replaceAllRows = (data: unknown[]) => ({
  type: ArrayActionType.REPLACE_ALL,
  payload: data,
})

const removeRow = (id: string) => ({
  type: ArrayActionType.REMOVE,
  payload: id,
})

const removeRowByIndex = (index?: number) => ({
  type: ArrayActionType.REMOVE_BY_INDEX,
  payload: index,
})

const updateRow = <T>(id: string, data: Partial<T>) => ({
  type: ArrayActionType.UPDATE,
  payload: { id, data },
})

const updateRowByIndex = <T>(index: number, data: Partial<T>) => ({
  type: ArrayActionType.UPDATE_BY_INDEX,
  payload: { index, data },
})

export const arrayReducerActionWrapper = <T>(label: string) => ({
  addRow: () => actionTypeWrapper(label, addRow()),
  replaceAllRows: (data: T[]) => actionTypeWrapper(label, replaceAllRows(data)),
  removeRow: (id: string) => actionTypeWrapper(label, removeRow(id)),
  updateRow: (id: string, data: Partial<T>) =>
    actionTypeWrapper(label, updateRow(id, data)),
  removeRowByIndex: (index?: number) =>
    actionTypeWrapper(label, removeRowByIndex(index)),
  updateRowByIndex: (index: number, data: Partial<T>) =>
    actionTypeWrapper(label, updateRowByIndex(index, data)),
})
